import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import type { AccountDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/account/';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const accountHolderSelector = selector<AccountDTO>({
    key: 'accountHolderSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        if (!isLoggedOn) return {};
        return await OnlineSales.getAccountHolderDetails(jobNumber, sessionId);
    }
});
